import { render, staticRenderFns } from "./Auth-public.vue?vue&type=template&id=a2a8cd40&"
import script from "./Auth-public.vue?vue&type=script&lang=js&"
export * from "./Auth-public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports